import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { key: 1 }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 1,
  class: "text-muted"
}

import { ref, onMounted, onUnmounted, computed } from 'vue';

import { EPINIO_TYPES } from '../types';
import { createEpinioRoute } from '../utils/custom-routing';
import DataTable from '../components/tables/DataTable.vue';
import type { DataTableColumn } from '../components/tables/types';
import LinkDetail from '@shell/components/formatter/LinkDetail.vue';
import BadgeStateFormatter from '@shell/components/formatter/BadgeStateFormatter.vue';
import Masthead from '@shell/components/ResourceList/Masthead';
import { useStore } from 'vuex';
import { startPolling, stopPolling } from '../utils/polling';


export default /*@__PURE__*/_defineComponent({
  __name: 'services',
  setup(__props) {

const pending = ref(true);
const store = useStore();
const t = store.getters['i18n/t'];

const schema = ref(store.getters['epinio/schemaFor'](EPINIO_TYPES.SERVICE_INSTANCE));
const resource = EPINIO_TYPES.SERVICE_INSTANCE;

const createLocation = computed(() =>
  createEpinioRoute('c-cluster-resource-create', {
    cluster: store.getters['clusterId'],
    resource: EPINIO_TYPES.SERVICE_INSTANCE,
  })
);

// Strict RBAC: only show Create when we know the user has service write perms (hides for view_only)
const canCreateService = computed(() => {
  const can = store.getters['epinio/can'];
  const perms = store.getters['epinio/permissions']?.();

  // If we don't have a permission helper or a populated perms map yet, hide Create
  if (!can || !perms || Object.keys(perms).length === 0) {
    return false;
  }

  return can('service_write') || can('service');
});

onMounted(async () => {
  await store.dispatch('epinio/me');
  await Promise.all([
    store.dispatch(`epinio/findAll`, { type: EPINIO_TYPES.APP }),
    store.dispatch(
      `epinio/findAll`,
      { type: EPINIO_TYPES.SERVICE_INSTANCE }
    ),
  ]);
  pending.value = false;

  startPolling(["namespaces", "applications", "services"], store);
});

onUnmounted(() => {
  stopPolling(["namespaces", "applications", "services"]);
});

const rows = computed(() => {
  return store.getters['epinio/all'](EPINIO_TYPES.SERVICE_INSTANCE);
});

const columns: DataTableColumn[] = [
  {
    field: 'stateDisplay',
    label: 'State',
    width: '100px'
  },
  {
    field: 'nameDisplay',
    label: 'Name'
  },
  {
    field: 'catalog_service',
    label: 'Catalog Service',
    sortable: false
  },
  {
    field: 'catalog_service_version',
    label: 'Catalog Service Version'
  },
  {
    field: 'boundApps',
    label: 'Bound Applications',
    sortable: false
  },
  {
    field: 'meta.createdAt',
    label: 'Age',
    formatter: 'age'
  }
];

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(Masthead), {
      schema: schema.value,
      resource: _unref(resource)
    }, {
      createButton: _withCtx(() => [
        (canCreateService.value)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "btn role-primary",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(store).$router.push(createLocation.value)))
            }, _toDisplayString(_unref(t)('generic.create')), 1))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["schema", "resource"]),
    _cache[5] || (_cache[5] = _createTextVNode()),
    _createVNode(DataTable, {
      rows: rows.value,
      columns: columns,
      loading: pending.value
    }, {
      "cell:stateDisplay": _withCtx(({ row }) => [
        _createVNode(BadgeStateFormatter, {
          row: row,
          value: row.stateDisplay
        }, null, 8, ["row", "value"])
      ]),
      "cell:nameDisplay": _withCtx(({ row }) => [
        _createVNode(LinkDetail, {
          row: row,
          value: row.nameDisplay
        }, null, 8, ["row", "value"])
      ]),
      "cell:catalog_service": _withCtx(({ row }) => [
        (row.serviceLocation)
          ? (_openBlock(), _createBlock(LinkDetail, {
              key: 0,
              row: { detailLocation: row.serviceLocation },
              value: row.catalog_service
            }, null, 8, ["row", "value"]))
          : (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(row.catalog_service), 1))
      ]),
      "cell:boundApps": _withCtx(({ row }) => [
        (row.applications && row.applications.length)
          ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.applications, (app, index) => {
                return (_openBlock(), _createElementBlock(_Fragment, {
                  key: app.id
                }, [
                  _createVNode(LinkDetail, {
                    row: app,
                    value: app.meta.name
                  }, null, 8, ["row", "value"]),
                  _cache[1] || (_cache[1] = _createTextVNode()),
                  (index < row.applications.length - 1)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: app.id + 'i'
                      }, ", "))
                    : _createCommentVNode("", true)
                ], 64))
              }), 128))
            ]))
          : (_openBlock(), _createElementBlock("span", _hoisted_3, " "))
      ]),
      _: 1,
      __: [2,3,4]
    }, 8, ["rows", "loading"])
  ], 64))
}
}

})